export const getLocalStorageGlobalListPageLimit = (): number => {
  const localStorageValue = window.localStorage.getItem('globalListPageLimit');
  return localStorageValue ? parseInt(localStorageValue, 10) : 50;
};

export const setLocalStorageGlobalListPageLimit = (value: string): void => {
  window.localStorage.setItem('globalListPageLimit', value);
};
